import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  items = [];

  constructor(private httpClient: HttpClient) {}

  getClients() {
    return this.httpClient.get('/assets/modules.json');
  }

  addClient() {
    
  }
}
